import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import AddEditNominee from "./AddEditNominee";
import {
  wishToAddNomineeApi,
  getNomineeApi,
  deleteNomineeApi,
  getRequestTypeStage,
  getRequestTypeDocs,
} from "designs/v1/pages/ModifyKyc/services";

const WishToAddNominee = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const [selectedNominee, setSelectedNominee] = useState(null);
  const [showNomineeForm, setShowNomineeForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [nomineeList, setNomineeList] = useState([]);
  const formFields = {
    nominee_name: "",
    email_id: "",
    mobile: "",
    nominee_dob: "",
    relationship_with_applicant: "",
    other_relationship: "",
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    country: "INDIA",
    pincode: "",
    type_of_identification: "",
    nominee_id_proof: "",
    nominee_id_proof_back: "",
    nominee_idproof_file_type: "",
    share_of_nominee: "",
    minor: "",
    guardian_name: "",
    guardian_mobile: "",
    guardian_email: "",
    guardian_dob: "",
    relationship_with_nomiee: "",
    id_type: "",
    guardian_id_proof: "",
    guardian_id_proof_back: "",
    guardian_idproof_file_type: "",
    guardian_address1: "",
    guardian_address2: "",
    guardian_city: "",
    guardian_state: "",
    guardian_country: "INDIA",
    guardian_pincode: "",
  };
  const [nomineeFormValue, setNomineeFormValue] = useState(formFields);
  const [initialValues, setInitialValues] = useState({
    wish_nominee: "",
  });

  useEffect(() => {
    loadNomineeApi();
  }, []);

  const loadNomineeApi = async () => {
    setIsLoading(true);
    let payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("NomineeRequestNumber"),
    };
    try {
      const resp = await getNomineeApi(payload);
      const data = resp.data?.data?.nominee_data || [];
      setNomineeList(data);
      if (data?.length > 0) {
        setInitialValues({ wish_nominee: "Yes" });
      } else {
        setInitialValues({ wish_nominee: "" });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const onValidateWishNominee = (values) => {
    const errors = {};
    if (!values.wish_nominee) {
      errors.wish_nominee = "Required";
    }
    return errors;
  };

  const nomineeTotalShare = (list) =>
    list.reduce(
      (sum, { share_of_nominee }) => sum + parseInt(share_of_nominee),
      0
    );

  const handleWishNomineeSubmit = async (value) => {
    if (!value.wish_nominee) {
      return toast.error("Please select an option.");
    }
    if (value.wish_nominee === "Yes") {
      if (nomineeList.length === 0) {
        return toast.error("Please add nominee.");
      }
      const totalShare = nomineeTotalShare(nomineeList);
      if (totalShare < 100) {
        return toast.error(`Error: Nominee's share cannot be less than 100%`);
      }
      console.log("activeUserDetail", activeUserDetail.nominations);
      console.log("nomineeList", nomineeList);
      if (activeUserDetail.nominations?.length > 0) {
        const results = (activeUserDetail.nominations || []).filter(
          (obj1) =>
            !nomineeList.some((obj2) => {
              return (
                obj2.nominee_name === obj1.nominee_name &&
                obj2.mobile === obj1.mobile &&
                obj2.relationship_with_applicant ===
                  obj1.relationship_with_applicant &&
                obj2.share_of_nominee == obj1.share_of__nominee &&
                obj2.guardian_name == obj1.guardian_name &&
                obj2.guardian_mobile == obj1.guardian_mobile &&
                obj2.date_of_birth == obj1.date_of_birth
              );
            })
        );
        if (results.length === 0) {
          return toast.error(
            "The old nominee's information is same as the new nominee's. please change"
          );
        }
      }
    }
    if (value.wish_nominee === "No") {
      if (nomineeList.length > 0) {
        return toast.error("Please delete your existing nominee.");
      }
    }
    setIsLoading(true);
    const payload = {
      ...value,
      request_type: stageScreen,
      doc_name: localStorage.getItem("NomineeRequestNumber"),
    };
    try {
      const resp = await wishToAddNomineeApi(payload);
      console.log("resp", resp);
      setIsLoading(false);
      const requestTypes = getRequestTypeStage();
      const requestTypesDocs = getRequestTypeDocs() || [];
      requestTypesDocs.push(payload.doc_name);
      if (requestTypes && requestTypes.length > 0) {
        requestTypes.shift();
        localStorage.setItem("RequestTypeStage", JSON.stringify(requestTypes));
        localStorage.setItem(
          "RequestTypeDocs",
          JSON.stringify(requestTypesDocs)
        );
        Swal.fire({
          title: "Nominee Modification Request Saved. Thank You..!",
          icon: "success",
          showCloseButton: false,
          showConfirmButton: false,
          timer: 3000,
        });
        if (requestTypes.length === 0) {
          setTimeout(async () => {
            await setStageScreen("MultipleRequestTypes");
          }, 3000);
          return;
        }
        setTimeout(async () => {
          await setStageScreen(requestTypes[0]);
        }, 3000);
        return;
      }
      setStep("NomineeModificationReview");
    } catch (error) {
      console.log("err", error);
      const { data } = error.response || {};
      toast.error(
        data.message?.message || "Internal server error!"
      );
      setIsLoading(false);
    }
  };
  const handleCloseForm = () => {
    setSelectedNominee(null);
    setShowNomineeForm(false);
    setIsView(false);
    setIsEdit(false);
  };

  const handleViewNominee = (item) => {
    setSelectedNominee(item);
    setShowNomineeForm(true);
    setIsView(true);
  };

  const handleEditNominee = (item) => {
    setSelectedNominee(item);
    setShowNomineeForm(true);
    setIsEdit(true);
  };

  const handleRemoveNominee = async (item) => {
    setIsLoading(true);
    let payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("NomineeRequestNumber"),
      id: item.name,
    };
    try {
      const resp = await deleteNomineeApi(payload);
      console.log("resp", resp.data?.data);
      setIsLoading(false);
      setNomineeList(nomineeList.filter((y) => y.name !== item.name));
    } catch (error) {
      const { response } = error;
      console.log("err", response);
      setIsLoading(false);
    }
  };
  return (
    <div>
      <Title title="Nominee Modification Details" />
      {!isLoading && (
        <div className="col-md-12 mt-3">
          <div className="ml-2">
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              validate={onValidateWishNominee}
              onSubmit={handleWishNomineeSubmit}
            >
              {({ values, isValid, dirty, isSubmitting, setFieldValue }) => (
                <Form>
                  {nomineeList.length < 3 &&
                    nomineeTotalShare(nomineeList) !== 100 && (
                      <div className="form-group my-2">
                        <label>Would you like to add nominee/s? *</label>
                        <div className="form-check mt-1">
                          <Field
                            className="form-check-input"
                            type="radio"
                            name="wish_nominee"
                            value="Yes"
                            // checked={values.wish_nominee === "Yes"}
                            onClick={() =>
                              nomineeList.length === 0 &&
                              setShowNomineeForm(true)
                            }
                          />
                          <label className="form-check-label">Yes</label>
                        </div>
                        <div className="form-check mt-1">
                          <Field
                            className="form-check-input"
                            type="radio"
                            name="wish_nominee"
                            value="No"
                            // checked={values.wish_nominee === "No"}
                          />
                          <label className="form-check-label">No</label>
                        </div>
                      </div>
                    )}

                  <div className="row">
                    {/* <div className="row">
                    <h6 className="col-sm">Nominee Details</h6>
                  </div> */}
                    {nomineeList.length > 0 && (
                      <table className="table mx-2">
                        <thead>
                          <tr>
                            {/* <th scope="col">Sr.no</th> */}
                            <th scope="col">Name</th>
                            <th scope="col">Mobile Number</th>
                            <th scope="col">Date of birth</th>
                            <th scope="col">Relationship</th>
                            <th scope="col">Share(%)</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {nomineeList.map((item) => {
                            return (
                              <tr key={item.name}>
                                {/* <th scope="row">{index + 1}</th> */}
                                <td>{item.nominee_name}</td>
                                <td>{item.mobile}</td>
                                <td>
                                  {item.nominee_dob
                                    ?.split("-")
                                    .reverse()
                                    .join("-")}
                                </td>
                                <td>{item.relationship_with_applicant}</td>
                                <td>{item.share_of_nominee}</td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-success mx-1"
                                    onClick={() => handleViewNominee(item)}
                                  >
                                    <i className="fa fa-eye"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-success mx-1"
                                    onClick={() => handleEditNominee(item)}
                                  >
                                    <i className="fa fa-pencil"></i>
                                  </button>
                                  <div
                                    type="button"
                                    className="btn btn-danger mx-1"
                                    onClick={() => handleRemoveNominee(item)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="d-flex form-group my-4">
                    <div className="mx-2">
                      <Button
                        type="button"
                        title="Back"
                        handleClick={() => setStep("DematUccForm")}
                        loading={isLoading}
                      />
                    </div>
                    <div className="mx-2">
                      <Button
                        title="Submit"
                        disabled={isLoading || !values.wish_nominee}
                      />
                    </div>
                    {values.wish_nominee === "Yes" &&
                      nomineeList.length < 3 &&
                      nomineeTotalShare(nomineeList) !== 100 && (
                        <div className="mx-2">
                          <Button
                            type="button"
                            title="Add Nominee"
                            handleClick={() => {
                              // if (nomineeTotalShare(nomineeList) === 100) {
                              //   return toast.error(
                              //     "Total Shares of nominee should not more than 100"
                              //   );
                              // }
                              setNomineeFormValue(formFields);
                              setShowNomineeForm(true);
                            }}
                            loading={isLoading}
                          />
                        </div>
                      )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}
      <Modal
        size="lg"
        backdrop="static"
        keyboard={false}
        show={showNomineeForm}
        onHide={handleCloseForm}
      >
        <Modal.Header>
          <Modal.Title>
            {isView ? "View Nominee" : isEdit ? "Edit Nominee" : "Add Nominee"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddEditNominee
            activeUserDetail={activeUserDetail}
            stageScreen={stageScreen}
            setStageScreen={setStageScreen}
            setStep={setStep}
            isLoading={isLoading}
            selectedNominee={selectedNominee}
            nomineeList={nomineeList}
            nomineeFormValue={nomineeFormValue}
            setNomineeFormValue={setNomineeFormValue}
            isEdit={isEdit}
            isView={isView}
            setIsLoading={setIsLoading}
            handleCloseForm={handleCloseForm}
            loadNomineeApi={loadNomineeApi}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default WishToAddNominee;
